<template>
    <div class="right-bar__ruler online">
        <h3 class="right-bar__header">{{ $t('translation.online') }}</h3>

        <div class="col">
            <h4 class="online__header">{{ $t('translation.siteMessage') }}</h4>
            <div class="online__body">
                <template v-for="ad in adAds">
                    <div v-html="replaceUrlToCurrentProtocol(ad.description_translation[0].translation)"></div>
                </template>
            </div>
            <div v-if="true" class="online__button">
                <button class="button-secondary">{{ $t('translation.openOurSite') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
    import adMixin from '../../../mixins/ad';
    import authMixin from '../../../mixins/auth';
    import replaceUrlToCurrentProtocol from '../../../utils/replaceUrlToCurrentProtocol';

    export default {
        mixins: [
            adMixin,
            authMixin,
        ],
        methods: {
            replaceUrlToCurrentProtocol,
            saveClick(id) {
                this.$store.dispatch('ad/addUserAd', {
                    id,
                })
            },
        },
        mounted() {
            this.$store.dispatch('ad/getAll', {
                site_places: [4],
            });
        },
  }
</script>



// WEBPACK FOOTER //
// src/components/Code/rightbar/Online.vue